<template>
  <b-form-group
    label="Menşei"
    label-for="origin"
  >
    <validation-provider
      #default="{ errors }"
      name="Menşei"
      rules="required"
    >
      <b-form-input
        id="origin"
        v-model="dataItem.origin"
        placeholder="Menşei"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'
import { ValidationProvider, localize } from 'vee-validate'
import { required } from '@validations'

export default {
  name: 'Origin',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['proformaInvoices/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
